import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';

import DotsLoading from '../../../components/dotsLoading';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import {HOME_TRAGET} from '../../../services/config';
import useGetMyAccess from '../../../services/hookService/getMyAccess/useGetMyAccess';

export enum PermissionRole {
  MANAGER = 1, // مدیر
  CONSULTANT = 2, // مشاور
  FOREMAN = 3, // سرکاگر
  WORKER = 4, // کارگر
  OWNER = 9, // مالک
}

export const ROLE_TITLES = {
  1: 'مدیر',
  2: 'مشاور',
  3: 'سرکارگر',
  4: 'کارگر',
  9: 'مالک',
} as const;

export type RoleId = keyof typeof ROLE_TITLES;

const MyAccess = () => {
  const {isLoading, data, loaderRef, isFetchingNextPage} = useGetMyAccess();
  const routeAccessHandle = () => {
    window.location.replace(`${HOME_TRAGET}/home`);
  };

  return (
    <div className="flex flex-col justify-between w-full h-full">
      <CustomHeader
        title={'دسترسی‌های من'}
        preIcon="icon-nameArrow---Right"
        isActiveRightIcon
      />
      <div className="flex-col w-full h-full gap-3 px-3 overflow-y-scroll d-flex">
        {isLoading ? (
          <div className="flex justify-center w-full pt-4">
            <DotsLoading />
          </div>
        ) : data?.length === 0 ? (
          <p className="flex justify-center w-full py-4 text-sm text-center text-gray-800 font-Medium">
            داده ای برای نمایش وجود ندارد!
          </p>
        ) : (
          data?.map((item, index) => (
            <div
              onClick={() => routeAccessHandle()}
              className="w-full my-3 flex min-h-[144px] px-3 items-center gap-2 rounded-[8px] shadow-sm flex-col"
              key={index}
            >
              <div className="flex w-full gap-2">
                {item.farm_image_url ? (
                  <img
                    className="w-[80px] h-[80px] rounded-lg min-w-[80px]"
                    src={item.farm_image_url}
                    alt="farm picture"
                  />
                ) : (
                  <div className="w-[80px] flex justify-center items-center bg-gray-100 h-[80px] rounded-lg min-w-[80px] ">
                    <img
                      width={40}
                      height={40}
                      className="rounded-sm "
                      src="https://s3.ir-thr-at1.arvanstorage.ir/farm-farm/satelite%201.svg"
                      alt="empty farm picture"
                    />
                  </div>
                )}

                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-1">
                    <span className="text-sm text-gray-700 font-Regular">
                      مساحت مزرعه:
                    </span>
                    <span className="text-sm text-gray-900 font-Regular">
                      {item?.masahat}
                    </span>
                  </div>
                  <div className="flex items-center gap-1">
                    <span className="text-sm text-gray-700 font-Regular">
                      مالک مزرعه:
                    </span>
                    <span className="text-sm text-gray-900 font-Regular">
                      {item?.owner_name}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex w-full items-center justify-between bg-green-50 min-h-[40px] rounded-[40px] px-1">
                <span className="mr-2 text-sm text-green-500 font-Regular">
                  سطح دسترسی:
                </span>
                <span className=" bg-white text-green-500 items-center ml-1 text-sm font-Regular rounded-xl h-[24px] px-2">
                  {getRoleTitleByNumber(item.farm_permission) ?? 'مشخص نشده'}
                </span>
              </div>

              {/* This div acts as a sentinel for triggering infinite scroll */}
              <div ref={loaderRef} className="mt-4 text-center">
                {isFetchingNextPage ? <DotsLoading /> : null}
              </div>
            </div>
          ))
        )}
      </div>{' '}
      <MainFooter />
    </div>
  );
};

export default MyAccess;
export const conventor: Record<string, string> = {
  owner: 'مالک',
  admin: 'مالک',
  manager: 'مشاور',
  contributor: 'سرکارگر',
  no_access: 'کارگر',
};

export function getRoleTitleByNumber(id: number): string | undefined {
  return ROLE_TITLES[id as RoleId];
}
